import { Component, OnDestroy, OnInit } from "@angular/core";
import { sweetAlert } from "../../../utils/swal";
import { ActivatedRoute, Router } from "@angular/router";
import * as _ from 'underscore';
import {
  getCompanyLogo,
  weekDays,
  exportToCsv,
} from "../../../utils/utils.common";
import { FleetService } from "../../fleet/fleet-service/fleet.service";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { DriversService } from "../drivers-service/drivers-service";
import { downloadFile } from "src/app/utils/pdf-downloader";
import { urls } from "src/app/utils/url-utils";
import { animate, style, transition, trigger } from "@angular/animations";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import * as moment from "moment";
import { LevelOfServiceService } from "../../level-of-service/service/level-of-service.service";
import { ServiceAreasService } from "../../service-areas/service-areas-service/service-areas.service";
import { EquipmentService } from "../../equipments/equipment-service/equipment.service";
import { forkJoin } from "rxjs";
import { StaffService } from "../../staffs/staff-service/staff.service";
import { CorporateService } from "../../corporate-user/corporate-service/corporate-service";

@Component({
  selector: "app-driver-list",
  templateUrl: "./driver-list.component.html",
  styleUrls: ["./driver-list.component.css"],
  animations: [
    trigger("fleetAssignModalAnimation", [

      transition(":enter", [
        style({ opacity: 0, transform: "translateX(100%)" }),
        animate(
          "750ms ease-in-out",
          style({ opacity: 1, transform: "translateX(0)" })
        )
      ]),

      transition(":leave", [
        style({ opacity: 1, transform: "translateX(0)" }),
        animate(
          "750ms ease-in-out",
          style({ opacity: 0, transform: "translateX(-100%)" })
        )
      ])

    ])
  ]
})
export class DriverListComponent implements OnInit, OnDestroy {
  driverList: any = [];
  search;
  selectedDriver: any;
  path = "";
  user;
  drivers: void[];
  selectedStatus: any = "active";
  driverDetailProfileModal;
  driverManifestModal;
  isTimelineSubmitted = false;
  timeZone;
  shift;
  updatedData;
  preLevelOfServices = {};
  showSlideFilter = false;
  shiftAlign = '';
  preServiceAreas = {};
  preEquipmentList = {};
  preSpaceTypes = {};
  serviceAreasList = [];
  competencyList = [];
  proficiencyList = [];
  selectedProficiencies = [];
  selectedCompetencies = [];
  selectedServiceAreas = [];
  filterDriverList = [];
  fleetsListModal = false;
  fleetData;
  days = weekDays;
  staffList = [];
  selectedStaff = [];
  preStaffList = {};
  preCorporateUsers: any = {};
  fundingSources = [];
  selectedFundingSources = [];
  preFundingSources = {};
  isFarmoutIntegration = false;
  isRdispatcher = false;
  superDrivers = [];
  todayDate;
  preShiftOverrides = {};
  selectedDropdownIndex = -1;
  toggleActionButtons = false;
  selectedDrivers = [];
   columnsSortOrder: any = {
    displayName: '',
    setiDecall: '',
  }

  constructor(
    private router: Router,
    private equipmentService: EquipmentService,
    private serviceArea: ServiceAreasService,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private actvatedRoute: ActivatedRoute,
    private levelOfServiceService: LevelOfServiceService,
    private staffService: StaffService,
    private corporateService: CorporateService
  ) { }

  ngOnInit() {
    this.makeCompulsoryCalls();
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypeList(),
      this.getServiceAreas(),
      this.getEquipmentList(),
      this.getStaffList(),
      this.getFundingSources()
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2, res3, res4, res5, res6]) => {

        if (res1) {
          this.preLevelOfServices = res1.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        if (res2) {
          this.preSpaceTypes = res2.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        if (res3) {
          this.preServiceAreas = res3.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        if (res4) {
          this.preEquipmentList = res4.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        if (res5) {
          this.preStaffList = res5.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        if (res6) {
          this.preCorporateUsers = res6.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        this.getUser();
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }


  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.timeZone = this.user.timeZone;
          this.todayDate = [
            moment().tz(this.timeZone).startOf('day').toISOString(),
            moment().tz(this.timeZone).endOf('day').toISOString()
          ];
          if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
            this.selectedStaff = [this.user.sId];
            this.isRdispatcher = true;
          }
          this.getDriverList();
          if (data.hasOwnProperty('isFarmout')) {
            this.isFarmoutIntegration = data.isFarmout
          }
        }
      });
  }

  getDriverList() {
    this.serviceAreasList = [];
    this.competencyList = [];
    this.proficiencyList = [];
    this.staffList = [];
    this.fundingSources = [];

    this.selectedProficiencies = [];
    this.selectedCompetencies = [];
    this.selectedServiceAreas = [];
    this.selectedFundingSources = [];
    this.selectedDrivers = [];

    this.driverService.getDrivers(this.user._id, this.selectedStatus)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.superDrivers = data.filter(driver => driver.profileRole === 'superdriver' && Array.isArray(driver.associateDrivers));;
            if (this.isRdispatcher) {
              data = data.filter(item => item.stationManager === this.user.sId);
            }
            this.driverList = data;
            this.filterDriverList = this.driverList;
            const column = Object.keys(this.columnsSortOrder)
              .find(key => this.columnsSortOrder[key]);
            if (column) {
              this.columnsSortOrder[column] = this.columnsSortOrder[column] === 'asc' ? 'desc' : 'asc';
              this.sortColumn(column);
            }

            for (let driver of this.driverList) {
              if (driver.fundingSources && driver.fundingSources.length) {
                const isFromBroker = driver.fundingSources.some(fs => fs.status === 'credentialed');
                if (isFromBroker) {
                  if (driver.profileImageURL && driver.profileImageURL.includes('document_required.png')) {
                    driver.profileImageURL = 'assets/images/placeholders/driver-placeholder.png';
                  }
                  driver.isFromBroker = true;
                }
              }
              if (driver.serviceAreas && driver.serviceAreas.length) {
                for (let area of driver.serviceAreas) {
                  if (area && this.preServiceAreas[area])
                    this.serviceAreasList.push(this.preServiceAreas[area]);
                }
              }

              if (driver.proficiency && driver.proficiency.length) {
                for (let proficiency of driver.proficiency) {
                  if (proficiency && this.preSpaceTypes[proficiency])
                    this.proficiencyList.push(this.preSpaceTypes[proficiency]);
                }
              }

              if (driver.competency && driver.competency.length) {
                for (let competency of driver.competency) {
                  if (competency && this.preEquipmentList[competency])
                    this.competencyList.push(this.preEquipmentList[competency]);
                }
              }
              if (driver.stationManager) {
                this.staffList.push(this.preStaffList[driver.stationManager]);
              }

              if (driver.fundingSources && driver.fundingSources.length) {
                for (let fundingSource of driver.fundingSources) {
                  const id = fundingSource.name;
                  if (id && this.preFundingSources[id]) {
                    this.fundingSources.push(this.preFundingSources[id]);
                  }
                }
              }
            }

            this.serviceAreasList = _.uniq(this.serviceAreasList, '_id').sort();
            this.proficiencyList = _.uniq(this.proficiencyList, '_id').sort();
            this.competencyList = _.uniq(this.competencyList, '_id').sort();
            this.staffList = _.uniq(this.staffList, '_id').sort();
            this.fundingSources = _.uniq(this.fundingSources, '_id').sort();
          }
          this.getShiftOverrides();
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getLevelOfService() {

    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypeList() {

    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getServiceAreas() {
    return this.serviceArea.getServiceAreas({ status: 'active' });
  }

  getEquipmentList() {
    let queryParams = {
      isAddon: false,
      status: 'active'
    }
    return this.equipmentService.getEquipments(queryParams);
  }

  getStaffList() {
    return this.staffService.getStaffList();
  }

  getFundingSources() {
    return this.corporateService.getCorporateUsers("active");
  }

  onChangeStatus() {
    this.getDriverList();
  }

  onClickProfile(driver) {
    this.driverDetailProfileModal = driver;
  }

  showDriverManifest(driver) {
    this.driverManifestModal = driver._id;
  }

  currentSelectedFleet(driver) {
    this.fleetsListModal = true;
    this.selectedDriver = driver;

  }

  generateQRCode(driver) {
    this.driverService.generateDriverQR(driver._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data && data.pdfName) {
          const name = data.pdfName;
          const url = urls.SERVER_URL + "pdf/" + name;
          downloadFile(url, "", name);
        }
      });
  }

  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  filterDrivers() {
    this.filterDriverList = this.driverList.filter(driver => {

      let isServiceAreasExist = true;
      let isCompetencyExist = true;
      let isProficiencyExist = true;
      let isShiftAlign = true;
      let isStaffExist = true;
      let isFundingSourceExist = true;

      if (driver.serviceAreas && this.selectedServiceAreas && this.selectedServiceAreas.length) {
        for (let item of this.selectedServiceAreas) {
          const isIncluded = driver.serviceAreas.includes(item)
          if (isIncluded) {
            isServiceAreasExist = true;
          } else {
            isServiceAreasExist = false;
            break;
          }
        }
      }

      if (driver.competency && this.selectedCompetencies && this.selectedCompetencies.length) {
        for (let item of this.selectedCompetencies) {
          const isIncluded = driver.competency.includes(item)
          if (isIncluded) {
            isServiceAreasExist = true;
          } else {
            isServiceAreasExist = false;
            break;
          }
        }
      }

      if (driver.proficiency && this.selectedProficiencies && this.selectedProficiencies.length) {
        for (let item of this.selectedProficiencies) {
          const isIncluded = driver.proficiency.includes(item)
          if (isIncluded) {
            isProficiencyExist = true;
          } else {
            isProficiencyExist = false;
            break;
          }
        }
      }

      if (driver.shiftAlign && this.shiftAlign) {
        isShiftAlign = driver.shiftAlign === this.shiftAlign;
      }
      if (driver.stationManager && this.selectedStaff && this.selectedStaff.length) {
        const isExist = this.selectedStaff.find(sId => sId === driver.stationManager);

        if (isExist) {
          isStaffExist = true;
        } else {
          isStaffExist = false;
        }
      }

      if (driver.fundingSources && this.selectedFundingSources && this.selectedFundingSources.length) {
        for (let id of this.selectedFundingSources) {
          const isIncluded = driver.fundingSources.find(fs => fs.name === id);
          if (isIncluded) {
            isFundingSourceExist = true;
          } else {
            isFundingSourceExist = false;
            break;
          }
        }
      }

      if (isServiceAreasExist && isCompetencyExist && isProficiencyExist && isShiftAlign && isStaffExist && isFundingSourceExist) {
        return true;
      } else {
        return false;
      }
    }
    );

    const column = Object.keys(this.columnsSortOrder)
      .find(key => this.columnsSortOrder[key]);
    if (column) {
      this.columnsSortOrder[column] = this.columnsSortOrder[column] === 'asc' ? 'desc' : 'asc';
      this.sortColumn(column);
    }
  }

  updateVehicle(event?) {
    if (event) {
      this.selectedDriver.isFleet = event.isFleet;
      this.selectedDriver.fleet = event.fleet;
    }
  }

  currentDayShift(shifts) {
    const currentDay = moment().tz(this.timeZone).day();
    if (shifts) {
      let shift = shifts.find(shift => shift.day === currentDay);
      return shift;
    } else {
      return {};
    }
  }

  associatedDriver(driver) {
    for (const superDriver of this.superDrivers) {
      if (superDriver.associateDrivers.includes(driver._id)) return superDriver;
    }
    return null;
  }

  onRouteChange(driver: string) {
    this.router.navigate(
      ['credentialing/drivers/tracking'],
      { state: { driver: driver } }
    );
  }


  getShiftOverrides() {
    const payload = {
      startDate: moment(this.todayDate[0]).tz(this.timeZone).toISOString(),
      endDate: moment(this.todayDate[1]).tz(this.timeZone).toISOString(),
      status:'active'
    }
    this.driverService.getShiftOverridesByDate(payload).subscribe(data => {
      this.preShiftOverrides = data.reduce((obj, item) => {
        if (!obj[item.driver._id]) {
          obj[item.driver._id] = [];
        }
        obj[item.driver._id].push(item);
        return obj;
      }, {});
      console.log(this.preShiftOverrides['66ba2c0434ec68dde0c506de']);
    });

  }



  showActionButtons(idx) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  onSelectDriver(driver) {
    const index = this.selectedDrivers.indexOf(driver._id);
    if (index > -1) {
      driver.isSelected = false;
      this.selectedDrivers.splice(index, 1);
    } else {
      driver.isSelected = true;
      this.selectedDrivers.push(driver._id);
    }
  }

  selectAllDrivers() {
    this.filterDriverList.forEach((driver) => {
      driver.isSelected = true;
      if (!this.selectedDrivers.includes(driver._id)) {
        this.selectedDrivers.push(driver._id);
      }
    });
  }

  unSelectAllDrivers() {
    this.filterDriverList.forEach((driver) => {
      driver.isSelected = false;
    });
    this.selectedDrivers = [];
  }

  forceLogoutSelectedDrivers() {
    if (!this.selectedDrivers.length) return;
    sweetAlert(
      "Alert",
      `Are you sure you want to force logout ${this.selectedDrivers.length} selected driver(s)?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.forceLogoutDrivers(this.selectedDrivers);
      }
    });
  }

  forceLogoutSingleDriver(driver) {
    sweetAlert(
      "Alert",
      `Are you sure you want to force logout ${driver.displayName}?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.forceLogoutDrivers([driver._id]);
      }
    });
  }

  forceLogoutDrivers(driverIds) {
    this.driverService.forceLogoutDrivers(driverIds)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        () => {
          const message = driverIds.length > 1 ? "Drivers logged out successfully!" : "Driver logged out successfully!";
          sweetAlert("Success", message, "success", "OK");
          this.unSelectAllDrivers();
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }


  sortColumn(column: string) {
    Object.keys(this.columnsSortOrder).forEach(col => {
      if (col !== column) {
        this.columnsSortOrder[col] = '';
      }
    })
    if (!this.columnsSortOrder[column]) {
      this.columnsSortOrder[column] = 'asc';
    } else {
      this.columnsSortOrder[column] = this.columnsSortOrder[column] === 'asc' ? 'desc' : 'asc';
    }

    this.filterDriverList.sort((a: any, b: any) => {
      let valA = a[column] || 0;
      let valB = b[column] || 0;

      if (column === 'setiDecall') {
        valA = (a && a.fleet && a.fleet.setiDecall) || 0;
        valB = (b && b.fleet && b.fleet.setiDecall) || 0;
      }

      // handle string numbers safely
      if (!isNaN(valA)) valA = Number(valA);
      if (!isNaN(valB)) valB = Number(valB);

      if (valA < valB) return this.columnsSortOrder[column] === 'asc' ? -1 : 1;
      if (valA > valB) return this.columnsSortOrder[column] === 'asc' ? 1 : -1;

      return 0;
    });

  }

  ngOnDestroy(): void {
  }

  driversCsvReport() {
    const table = [
      [
        "Name",
        "Email",
        "Mobile Number",
        "Address",
        "Employee Id",
        "License Number",
        "Employment Type",
        "Role/Source",
        "Version",
        "Staff Manager",
        "Cost Center",
        "Vehicle",
        "Competency",
        "Proficiency",
        "Service Area(s)",
        "Funding Source",
        "Status",
        "Shift (Sun)",
        "Shift (Mon)",
        "Shift (Tue)",
        "Shift (Wed)",
        "Shift (Thu)",
        "Shift (Fri)",
        "Shift (Sat)"
      ]
    ];

    this.filterDriverList.forEach((driver: any) => {

      const serviceAreas = (driver.serviceAreas && this.preServiceAreas) ? driver.serviceAreas.map((serviceArea: any) => this.preServiceAreas[serviceArea] ? this.preServiceAreas[serviceArea].name : '').filter(Boolean).join(', ') : '';

      const fundingsource = (driver.fundingSources && this.preCorporateUsers) ? driver.fundingSources.map((fs: any) => this.preCorporateUsers[fs.name] ? this.preCorporateUsers[fs.name].displayName : '').filter(Boolean).join(', ') : '';

      const los = (this.preLevelOfServices && driver.fleet && driver.fleet.los) ? this.preLevelOfServices[driver.fleet.los].title : '';

      const spaceType = (this.preSpaceTypes && driver.fleet && driver.fleet.spaceType) ? this.preSpaceTypes[driver.fleet.spaceType].title : '';

      const vehicle = los && spaceType ? `${los} (${spaceType})` : los || spaceType || '';

      const competencies = (driver.competency && this.preEquipmentList) ? driver.competency.map((competency: any) => this.preEquipmentList[competency] ? this.preEquipmentList[competency].title : '').filter(Boolean).join(', ') : '';

      const proficiency = (driver.proficiency && this.preSpaceTypes) ? driver.proficiency.map((proficiency: any) => this.preSpaceTypes[proficiency] ? this.preSpaceTypes[proficiency].title : '').filter(Boolean).join(', ') : '';

      const shiftColumns = Array(7).fill(' ');

      for (const s of driver.shifts || []) {
        if (s.isEnabled) {
          const align = s.shiftAlign ? ` - ${s.shiftAlign}` : '';
          shiftColumns[s.day] = `${s.checkin}-${s.checkout}${align}`
        }
      }

      const data = [
        driver.displayName || '',
        driver.email || '',
        driver.contactNumber || '',
        driver.address || '',
        driver.employeeId || '',
        driver.driverLicenseNumber || '',
        driver.type || '',
        `${driver.profileRole || ''}/${driver.source || ''}`,
        driver.buildVersion || 'N/A',
        this.preStaffList && this.preStaffList[driver.stationManager] ? this.preStaffList[driver.stationManager].displayName : '',
        driver.costCenter || '',
        vehicle,
        competencies,
        proficiency,
        serviceAreas,
        fundingsource,
        driver.accountStatus || '',
        ...shiftColumns
      ];

      table.push(data);
    });

    exportToCsv(`Drivers_Report.csv`, table);
  }

  driverCsvReport2() {
    const table = [
      [
        "Name",
        "Contact Number",
        "Vehicle",
        "Service Area(s)",
        "Status",
        "Driver's License"
      ]
    ];

    this.filterDriverList.forEach((driver: any) => {

      const serviceAreas = (driver.serviceAreas && this.preServiceAreas) ? driver.serviceAreas.map((serviceArea: any) => this.preServiceAreas[serviceArea] ? this.preServiceAreas[serviceArea].name : '').filter(Boolean).join(', ') : '';

      const los = (this.preLevelOfServices && driver.fleet && driver.fleet.los && this.preLevelOfServices[driver.fleet.los]) ? this.preLevelOfServices[driver.fleet.los].title : '';

      const spaceType = (this.preSpaceTypes && driver.fleet && driver.fleet.spaceType && this.preSpaceTypes[driver.fleet.spaceType]) ? this.preSpaceTypes[driver.fleet.spaceType].title : '';

      const vehicle = los && spaceType ? `${los} (${spaceType})` : los || spaceType || '';

      const data = [
        driver.displayName || '',
        driver.contactNumber || '',
        vehicle,
        serviceAreas,
        driver.accountStatus || '',
        driver.driverLicenseNumber || ''
      ];

      table.push(data);
    });

    exportToCsv(`Drivers_Report.csv`, table);
  }
}
